import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CustomerModel } from "../../models/CustomerModel";
import CustomerService from "../../services/CustomerService";
import CustomerSlice from "../slices/CustomerSlice";
import { RootState } from "../store";

export const CustomerActions = CustomerSlice.actions;
export const fetchCustomers = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(CustomerActions.setIsCustomersFetching(true));
    const response: CustomerModel[] = await CustomerService.getAllCustomers();
    dispatch(CustomerActions.setCustomers(response));
    dispatch(CustomerActions.setIsCustomersFetching(false));
  };
};
export const fetchParticularCustomer = (
  Customer_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: CustomerModel = await CustomerService.getParticularCustomer(
      Customer_id
    );
    dispatch(CustomerActions.setParticularCustomer(response));
  };
};
